import { Controller } from "react-hook-form";
import { commonFormProps } from "../../../utils/typeDefs";
import { Input } from "rsuite";

const InputTextArea = ({
  title,
  inputName,
  errors,
  control,
  inputErrorMessage,
  defaultInput,
  placeholder,
  rules,
}: commonFormProps) => {
  return (
    <div className="row pb-2 form-input-field">
      <div className="col-12 col-md-3 my-auto">
        <p className="form-label">
          {title}: {errors && inputErrorMessage("Required")}
        </p>
      </div>
      <div className="col-12 col-md-9">
        <Controller
          name={inputName}
          control={control}
          rules={rules}
          render={({ field }) => (
            <Input
              as="textarea"
              rows={2}
              value={field.value}
              onChange={field.onChange}
              inputRef={field.ref}
              placeholder={placeholder}
            />
          )}
          defaultValue={defaultInput}
        />
      </div>
    </div>
  );
};

export default InputTextArea;
